// Test IDs para el modulo de Pagos con Square.

export const PAYMENTS = {
  page: 'payments-page',
  newChargeButton: 'payments-new-charge-button',
  linksTable: 'payments-links-table',
  linksEmptyState: 'payments-links-empty-state',
  linkRowPrefix: 'payments-link-row-', // + linkId
  linkCopyButtonPrefix: 'payments-link-copy-button-',
  linkStatusBadgePrefix: 'payments-link-status-badge-',
  paymentsTable: 'payments-charges-table',
  paymentsEmptyState: 'payments-charges-empty-state',
  paymentRowPrefix: 'payments-charge-row-',
  paymentReceiptLinkPrefix: 'payments-charge-receipt-link-',
  notConnectedNotice: 'payments-not-connected-notice',
  goToSettingsButton: 'payments-go-to-settings-button',

  // Modal unificado (link de cobro / cobro presencial)
  chargeModal: 'payments-charge-modal',
  chargeModalPatientPicker: 'payments-charge-modal-patient-picker',
  chargeModalTabLink: 'payments-charge-modal-tab-link',
  chargeModalTabCard: 'payments-charge-modal-tab-card',
  chargeModalAmountInput: 'payments-charge-modal-amount-input',
  chargeModalDepositToggle: 'payments-charge-modal-deposit-toggle',
  chargeModalNoteInput: 'payments-charge-modal-note-input',
  chargeModalCardContainer: 'payments-charge-modal-card-container',
  chargeModalGenerateLinkButton: 'payments-charge-modal-generate-link-button',
  chargeModalChargeButton: 'payments-charge-modal-charge-button',
  chargeModalCancelButton: 'payments-charge-modal-cancel-button',
  chargeModalLinkResultUrl: 'payments-charge-modal-link-result-url',
  chargeModalLinkResultCopyButton: 'payments-charge-modal-link-result-copy-button',
  chargeModalChargeSuccessReceiptLink: 'payments-charge-modal-charge-success-receipt-link',

  // Card de Ajustes (conexion con Square)
  squareSettingsCard: 'settings-square-card',
  squareConnectButton: 'settings-square-connect-button',
  squareDisconnectButton: 'settings-square-disconnect-button',
  squareConnectedBadge: 'settings-square-connected-badge',
  squareNotConnectedBadge: 'settings-square-not-connected-badge',
  squareEnvironmentBadge: 'settings-square-environment-badge',
  squareBaseUrlWarning: 'settings-square-base-url-warning',

  // Botón dentro de la ficha de paciente / turno
  patientTabChargeButton: 'patients-payments-square-charge-button',
  appointmentChargeButton: 'agenda-detail-charge-button',
};
